export default __webpack_public_path__ + "static/media/safe_environment.44923713.png";